import angular from 'angular';
import CategoriesMenu from './categories-menu.component';

let CategoriesMenuModule = angular.module('catalog.categoriesMenu', [])
  .component('categoriesMenu', CategoriesMenu);

export default CategoriesMenuModule;



// WEBPACK FOOTER //
// ./www/components/home/categories-menu/categories-menu.js